export default __webpack_public_path__ + "assets/favicon.d4a79b31.jpg";